import React, { useState } from 'react'
import { Box, Button, IconButton, Modal, Typography } from '@mui/material';
import { Close } from '@mui/icons-material';

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '800px',
    maxWidth: '95%',
    bgcolor: 'var(--primary-bg)',
    border: '2px solid var(--primary-border)',
    boxShadow: 24,
    padding: '1rem',
    borderRadius: '8px'
}

const StakeRules = () => {

    const [isOpen, setIsOpen] = useState(false)
    const handleClose = () =>  setIsOpen(false)
    const handleOpen = () => setIsOpen(true)

  return (
    <>
        <Button disableRipple variant="text" color="inherit" sx={{ color: '#3c78c2', textTransform: 'capitalize', '&:hover': { color: '#3c78c2'} }} onClick={handleOpen}>
            Additional Rules     
        </Button>
        <Modal
            open={isOpen}
            onClose={handleClose}

        >
            <Box display="flex" flexDirection="column" gap="1rem" position="relative" sx={{ ...style, maxHeight: '80%' }}>
                <IconButton sx={{ position: 'absolute', top: '0', right: '0' }}>
                    <Close onClick={handleClose} />
                </IconButton>
                <Typography variant="h5">Stake Leaderboard Rules</Typography>

                <Box sx={{ overflowY: 'auto', px: '.25rem'}}>
                    <p>Games with RTP of 98% or lower → 100% of wagered amount will count</p>

                    <p>Games with RTP above 98% → 50% of wagered amount will count</p>

                    <p>Games with RTP of 99% or higher → 10% of wagered amount will count</p>

                    <p>Abusers will be removed from the leaderboard and have their prize forfeited.</p>
                </Box>


            </Box>
        </Modal>
    </>
  )
}

export default StakeRules